export default "__VITE_ASSET__CxNGSZ2R__"